import React from "react";
import FormFooter from "forms/components/FormFooter";
import PropTypes from "prop-types";

import SubmitButton from "components/SubmitButton";
import Translate from "utils/translate";

import Broker from "./Broker";
import PortfolioAsset from "./PortfolioAsset";

import styles from "forms/forms.css";































const { t } = new Translate("BrokerInviteForm");

const BrokerInviteForm = ({ formik: { handleSubmit, isSubmitting }, isAssetDetailPage }) => (
  <form className={styles.form} onSubmit={handleSubmit}>
    {!isAssetDetailPage && <PortfolioAsset />}
    <Broker />

    <FormFooter>
      <SubmitButton
        isSubmitting={isSubmitting}
        submitLabel={t("invite")}
        submittingLabel={t("inviting")}
      />
    </FormFooter>
  </form>
);

BrokerInviteForm.propTypes = {
  formik: PropTypes.shape({
    handleSubmit: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool,
  }),
  isAssetDetailPage: PropTypes.bool,
};

export default BrokerInviteForm;
